import React, { useState, useRef, useEffect } from 'react'
import { IoMdCheckmark } from 'react-icons/io'
import { useShop } from '../../../Providers/ShopProvider'
import { NumberBox } from 'devextreme-react/number-box'
import RangeSlider from 'devextreme-react/range-slider';

import '../Styles/ProductGlobalFiltersStyles.css'

const ProductGlobalFilters = () => {
    const priceFromRef = useRef(null)
    const priceToRef = useRef(null)
    const { productsFilter, setProductsFilter } = useShop()

    //const [priceFrom, setPriceFrom] = useState(productsFilter.PriceFrom)
    //const [priceTo, setPriceTo] = useState(productsFilter.PriceTo)

    //const [timeoutId, setTimeoutId] = useState(null)

    const handleFilterClick = (value) => {
        setProductsFilter(prev => ({
            ...prev,
            [value]: !prev[value]
        }))
    }
    const isFilterActive = (value) => {
        return productsFilter[value]
    }
    const handlePriceChange = (e, type) => {
        const value = e.value ? e.value : 0
        if (type === 'PriceFrom') {
            //setPriceFrom(value)
            setProductsFilter(prev => ({
                ...prev,
                PriceFrom: value,
            }))
        }
        else {
            //setPriceTo(value)
            setProductsFilter(prev => ({
                ...prev,
                PriceTo: value,
            }))
        }
    }
    const handlePriceInputKeyDown = (e) => {
        if (e.event.key === '-' || e.event.key === 'e' || e.event.key === 'E') {
            e.event.preventDefault()
        }
    }
    const handlePriceInputFocus = (inputName) => {
        const inputElement = inputName === 'PriceFrom' ? priceFromRef.current?.instance?._input() : priceToRef.current?.instance?._input()
        if (inputElement && inputElement.length > 0) {
            inputElement[0].select()
        }
    }
    // const handleRangeSliderChange = (e) => {
    //     const [from, to] = e.value
    //     setPriceFrom(from)
    //     setPriceTo(to)
    //     if (timeoutId) {
    //         clearTimeout(timeoutId);
    //     }
    //     const newTimeoutId = setTimeout(() => {
    //         setProductsFilter(prev => ({
    //             ...prev,
    //             PriceFrom: from,
    //             PriceTo: to
    //         }))
    //     }, 1000)
    //     setTimeoutId(newTimeoutId)
    // }

    const isPromoActive = isFilterActive('IsPromo')
    const isSellOutActive = isFilterActive('IsSellOut')
    const isNewActive = isFilterActive('IsNew')
    const isAllArticles = isFilterActive('AllArticles')

    return (
        <>
            <div className='feature'>
                <div className="row">
                    <div className="col-6 d-flex align-items-center">
                        <b>Promocja</b>
                    </div>
                    <div className="col-6 d-flex align-items-center justify-content-end" onClick={() => handleFilterClick('IsPromo')}>
                        <div className={`col-1 checkbox ${isPromoActive ? 'checked' : 'unchecked'}`}>
                            {isPromoActive &&
                                <span className="checkmark">
                                    <IoMdCheckmark />
                                </span>}
                        </div>
                    </div>
                </div>
            </div>
            <div className='feature'>
                <div className="row">
                    <div className="col-6 d-flex align-items-center">
                        <b>Wyprzedaż</b>
                    </div>
                    <div className="col-6 d-flex align-items-center justify-content-end" onClick={() => handleFilterClick('IsSellOut')}>
                        <div className={`col-1 checkbox ${isSellOutActive ? 'checked' : 'unchecked'}`}>
                            {isSellOutActive &&
                                <span className="checkmark">
                                    <IoMdCheckmark />
                                </span>}
                        </div>
                    </div>
                </div>
            </div>
            <div className='feature'>
                <div className="row">
                    <div className="col-6 d-flex align-items-center">
                        <b>Nowość</b>
                    </div>
                    <div className="col-6 d-flex align-items-center justify-content-end" onClick={() => handleFilterClick('IsNew')}>
                        <div className={`col-1 checkbox ${isNewActive ? 'checked' : 'unchecked'}`}>
                            {isNewActive &&
                                <span className="checkmark">
                                    <IoMdCheckmark />
                                </span>}
                        </div>
                    </div>
                </div>
            </div>
            <div className='feature d-flex flex-column mb-3'>
                <b className='mb-3'>Cena</b>
                {/* <RangeSlider
                    value={[priceFrom, priceTo]}
                    min={0}
                    max={50000}
                    elementAttr={{ class: "my-custom-range-slider" }}
                    onValueChanged={handleRangeSliderChange}
                /> */}
                <div className="row mt-3">
                    <div className="col-6 d-flex align-items-center">
                        <b className='me-2'>Od :</b>
                        <NumberBox
                            value={productsFilter.PriceFrom}
                            // min={0}
                            // max={50000}
                            showSpinButtons={false}
                            width={'60%'}
                            onValueChanged={(e) => handlePriceChange(e, 'PriceFrom')}
                            onKeyDown={(e) => handlePriceInputKeyDown(e)}
                            ref={priceFromRef}
                            onFocusIn={() => handlePriceInputFocus('PriceFrom')}
                        />
                    </div>
                    <div className="col-6 d-flex justify-content-end d-flex align-items-center">
                        <b className='me-2'>Do :</b>
                        <NumberBox
                            value={productsFilter.PriceTo}
                            // min={0}
                            // max={50000}
                            showSpinButtons={false}
                            width={'60%'}
                            onValueChanged={(e) => handlePriceChange(e, 'PriceTo')}
                            onKeyDown={(e) => handlePriceInputKeyDown(e)}
                            ref={priceToRef}
                            onFocusIn={() => handlePriceInputFocus('PriceTo')}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProductGlobalFilters
